var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4328_37952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5749 12.9404L48.9919 5.11876C48.8326 4.97319 48.6182 4.89843 48.4018 4.91614C48.1854 4.93187 47.9867 5.03614 47.849 5.20532L20.7211 38.6656L14.1132 29.5515C13.9873 29.3765 13.7945 29.2624 13.5801 29.2329C13.3677 29.2034 13.1513 29.2643 12.9821 29.3981L4.29094 36.3679C4.11389 36.5096 4.00766 36.7201 3.99783 36.9443C3.98799 37.1706 4.07455 37.3889 4.23586 37.5463L19.6588 52.4735C19.8064 52.6152 20.0031 52.6958 20.2057 52.6958H20.2195C20.428 52.6919 20.6286 52.6053 20.7723 52.4538L57.6123 14.0656C57.7598 13.9122 57.8385 13.7056 57.8306 13.4952C57.8227 13.2847 57.7303 13.082 57.5749 12.9404ZM20.188 50.7955L5.97291 37.0388L9.93488 33.8617L20.0641 44.6283L52.3834 10.3378L55.9185 13.5601L20.188 50.7955Z",
    fill: "#0C62FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4328_37952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.8fdd562a9736b04fb3332a45c9204f5b.svg";
export { ForwardRef as ReactComponent };